import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
  ConfirmPreliminaryOrderResult,
  OrderService,
} from 'src/app/entities/order';

export interface OrderConfirmDialogData {
  orderId: string;
  orderLabel?: string | number | null;
}

@Component({
  selector: 'app-order-confirm-dialog',
  standalone: true,
  templateUrl: './order-confirm-dialog.component.html',
  styleUrls: ['./order-confirm-dialog.component.scss'],
  imports: [CommonModule, MatDialogModule, TablerIconsModule],
})
export class OrderConfirmDialogComponent {
  saving = false;
  error = '';

  constructor(
    private readonly orderService: OrderService,
    private readonly dialogRef: MatDialogRef<
      OrderConfirmDialogComponent,
      ConfirmPreliminaryOrderResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: OrderConfirmDialogData,
  ) {}

  close(): void {
    if (this.saving) {
      return;
    }
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.saving) {
      return;
    }
    this.saving = true;
    this.error = '';
    this.orderService.confirmPreliminaryOrder(this.data.orderId).subscribe({
      next: (result) => {
        this.saving = false;
        this.dialogRef.close(result);
      },
      error: () => {
        this.saving = false;
        this.error = 'No se pudo confirmar la OS.';
      },
    });
  }
}
